import BlogRootDynamicContent from "./BlogRootDynamicContent";

export default BlogRootDynamicContent;
